import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AuthLayout } from '@/components/auth-layout';
import { useAuth } from '@/components/auth-provider';
import { LoginForm } from '@/components/login-form';

export const Route = createFileRoute('/_auth')({
  component: RouteComponent,
});

function RouteComponent() {
  const auth = useAuth();

  if (auth.isSuccess) {
    return (
      <AuthLayout>
        <Outlet />
      </AuthLayout>
    );
  }

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <LoginForm />
      </div>
    </div>
  );
}
